import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Configure, Index } from 'react-instantsearch-dom';

import { ALGOLIA_INDEX_NAME } from 'commons/constants';
import { SearchCount, CATEGORY_INDEX_MAPPING } from '../../commons/helpers';
import ProductSearchCount from './ProductSearchCount';

import MenuButtonLabel from './MenuButtonLabel';
import useMobileSearchFiltersTitle from '../hooks/useMobileSearchFiltersTitle';

const MobileSearchFilters = ({
  expandableOpen,
  index,
  onIndexChange,
  searchState,
  setExpandableOpen,
}) => {
  const searchTitle = useMobileSearchFiltersTitle(index);

  return (
    <div
      className={classNames('lg:hidden mobile-filters', {
        'mobile-filters--showTopBorder': true,
      })}
    >
      <div className="flex items-center divide-x divide-gray-light7">
        <button
          type="button"
          onClick={() => {
            setExpandableOpen(!expandableOpen);
          }}
          className={classNames(
            'flex-1 min-h-[3rem] space-x-1 flex items-center justify-center text-sm font-bold',
            {
              'mobile-filters__menu-expandable-button--open': expandableOpen,
            }
          )}
          aria-label="Toggle filters"
        >
          <MenuButtonLabel title={searchTitle} />
        </button>
      </div>

      <div
        className={classNames('mobile-filters__expandable relative -top-px', {
          'mobile-filters__expandable--open border-b border-gray-light6': expandableOpen,
          hidden: !expandableOpen,
        })}
      >
        <div className="text-base text-gray font-normal">
          <Index indexName={ALGOLIA_INDEX_NAME.PRODUCTS}>
            <Configure
              facets={['*']}
              facetFilters={searchState.configure.facetFilters}
              numericFilters={[
                'item_availability<2',
                'visibility>0',
                'visibility<4',
              ]}
              getRankingInfo
            />
            <ProductSearchCount
              title="Products"
              id={CATEGORY_INDEX_MAPPING.products}
              selectedOption={index}
              indexClick={onIndexChange}
            />
          </Index>
          <Index indexName={ALGOLIA_INDEX_NAME.CATEGORIES}>
            <Configure
              numericFilters={['fk_store_id=1']}
              facetFilters={['is_searchable:1']}
              getRankingInfo
            />
          </Index>
          <Index indexName="customer_photos">
            <Configure
              facets={['*']}
              numericFilters=""
              facetFilters={searchState.configure.facetFilters}
            />
            <SearchCount
              title="Customer Photos"
              id={CATEGORY_INDEX_MAPPING['customer photos']}
              selectedOption={index}
              indexClick={onIndexChange}
            />
          </Index>
          <Index indexName="reviews">
            <Configure facets={['*']} numericFilters="" facetFilters="" />
            <SearchCount
              title="Reviews"
              id={CATEGORY_INDEX_MAPPING.reviews}
              selectedOption={index}
              indexClick={onIndexChange}
            />
          </Index>
          <Index indexName={ALGOLIA_INDEX_NAME.STATIC_PAGES}>
            <Configure
              numericFilters={[
                'is_active=1',
                'show_in_search=1',
                'fk_store_id=1',
              ]}
            />
            <SearchCount
              title="Pages"
              id={CATEGORY_INDEX_MAPPING.pages}
              selectedOption={index}
              indexClick={onIndexChange}
            />
          </Index>
        </div>
      </div>
    </div>
  );
};

MobileSearchFilters.propTypes = {
  expandableOpen: PropTypes.bool,
  setExpandableOpen: PropTypes.func,
  index: PropTypes.string,
  filtersState: PropTypes.shape({
    isMaterialFiltered: PropTypes.shape({
      Fabric: PropTypes.bool,
      Leather: PropTypes.bool,
      Wood: PropTypes.bool,
    }),
    colorFiltered: PropTypes.shape({
      isFiltered: PropTypes.bool,
      currentColor: PropTypes.array,
    }),
    isFiltered: PropTypes.bool,
    typeFiltered: PropTypes.shape({
      isFiltered: PropTypes.bool,
      currentType: PropTypes.string,
    }),
    selectedFiltersList: PropTypes.array,
  }),
  onIndexChange: PropTypes.func,
  searchState: PropTypes.shape({
    query: PropTypes.string,
    configure: {
      facetFilters: PropTypes.string,
      facets: PropTypes.array,
    },
    hitsPerPage: 12,
    page: 1,
  }),
};

export default MobileSearchFilters;
